import createReactComponent from '../createReactComponent';
export default createReactComponent('letter-v', 'IconLetterV', [
  ['path', { d: 'M6 4l6 16l6 -16', key: 'svg-0' }],
]);
